import React from "react";
import Types from "prop-types";
import LanguageSelector from "../../LanguageSelector";
import { ReCaptcha } from "../../Guard";
import { Helmet } from "react-helmet";
import { withTranslation } from "react-i18next";

export class InstantCredentialsForm extends React.Component {

  render() {
    const { t, error, submitting } = this.props;
    return (
      <form onSubmit={this.props.onSubmit}>
        <Helmet>
          <title>Login | Careem</title>
        </Helmet>

        <LanguageSelector />
        <h1>{t("login:title")}</h1>


        {error && <div className="invalid show">{error}</div>}

        <div className="material-form-field">
          <input
            autoFocus
            type="text"
            autoComplete="username"
            id="instantCredentialsUserId"
            name="instantCredentialsUserId"
            onChange={this.props.onInstantCredentialsUserIdChange}
            required={true}
          />
          <label className="material-form-field-label" htmlFor="instantCredentialsUserId">
            {t("login:User ID")}
          </label>
        </div>

        <div className="material-form-field">
          <input
            type="password"
            autoComplete="current-password"
            id="password"
            name="password"
            onChange={this.props.onPasswordChange}
            required={true}
          />
          <label className="material-form-field-label" htmlFor="password">
            {t("login:password")}
          </label>
        </div>

        <input
          className="btn-careem"
          type="submit"
          value={submitting ? t("common:please_wait") : t("common:continue")}
          name="verify-recover-btn"
          disabled={submitting}
        />

        <ReCaptcha />
      </form>
    );
  }
}

InstantCredentialsForm.propTypes = {
  t: Types.func.isRequired,
  error: Types.string,
  onInstantCredentialsUserIdChange: Types.func.isRequired,
  onPasswordChange: Types.func.isRequired,
  onSubmit: Types.func.isRequired,
  submitting: Types.bool.isRequired,
};
export default withTranslation()(InstantCredentialsForm);
